// extracted by mini-css-extract-plugin
module.exports = {"root":"RadioCard_root__OrX70","label":"RadioCard_label__5nAul","description":"RadioCard_description__YQDMa"};